import { ref } from 'vue'
import axios from '@/api'
import type { CallerId } from '@/types/types'

// Module-level singletons so the outbound-call form fields are shared between
// App.vue (makeOutboundCall, confirmAndCall, toggleNewCall, initial caller-id
// fetch) and the TabNewCall component that renders the form.
const fname = ref<string | null>(null)
const lname = ref<string | null>(null)
const phone_number = ref<string | null>(null)
const caller_id = ref<number | null>(null)
const caller_ids = ref<CallerId[]>([])

const getCallerIds = async () => {
  const response = await axios.get('/api/v1/callerids')
  // The endpoint can hand back null / a non-array (no caller ids configured, an
  // empty body), and the template reads caller_ids.length directly — assigning
  // that straight through made the list null and crashed the render
  // ("Cannot read properties of null (reading 'length')"). Keep the invariant
  // that caller_ids is always an array.
  caller_ids.value = Array.isArray(response.data) ? response.data : []
}

export function useDialer() {
  return { fname, lname, phone_number, caller_id, caller_ids, getCallerIds }
}
